<template>
	<div :class="$style.header" :style="computedWidth">
      <div :class="$style.logo" @click.stop="$projCommon.navTo({path: '/'}, {})">
        <img v-if="logo" :src="logo" />
        <!--img v-else src="../../assets/images/inesajxjy/logo.png" /-->
      </div>
      <div v-if="isLogined" :class="$style.right">
      	<container-logout style="top: -22px;">
          <template slot-scope="p">
            <span :class="$style.app" @click.stop="$projCommon.navTo({path: '/'}, {})">
              <i class="el-icon-my-home" style="font-size: 18px;"></i>
              <span style="position: relative; top: -2px;">首页</span>
            </span>
            <div :class="$style.app">
          		<span @click.stop="$projCommon.navTo({path: '/uc'}, {})">
                个人中心
              </span>
              <container-roles style="display: inline-block;">
                <template slot-scope="p">
                  <span v-if="p.model" style="position: relative; top: -1px;">|</span>
                  <span v-if="p.model" @click.stop="$router.push({path: '/org', query: {refresh: true}})">后台管理</span>
                </template>
              </container-roles>
          	</div><!-- gap eliminted
	      	--><div :class="$style.logout" @click="p.logout">
            <i class="el-icon-my-logout" style="font-size: 14px; position: relative; top: 1px;"></i>
            <span>注销</span>
          </div>
          </template>
        </container-logout>
      </div>
      <div v-else :class="$style.right">
        <span :class="$style.app" @click.stop="$projCommon.navTo({path: '/login'}, {})">
          <i class="el-icon-my-home" style="font-size: 18px;"></i>
          <span style="position: relative; top: -2px;">登录</span>
        </span>
      </div>
	</div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import containerLogout from '@/containers/auth/containerLogout'
  import containerUser from '@/containers/auth/containerUser'
  import containerRoles from '@/containers/auth/containerGetRoles'
  import { getCookie } from '@/store/cookies.js'
  export default {
  	components: { containerLogout, containerUser, containerRoles },
    data () {
  	  return {
  	    logo: ''
      }
    },
    created () {
      this.getOrgIdByCode(process.env.DEFAULT_ORGCODE).then((r) => {
        if (r) {
          let orgid = r[0].id
          this.getModel(orgid)
        }
      })
    },
  	computed: {
  	  isLogined () {
  	    return !!getCookie(process.env.TOKEN_KEY)
      },
  	  computedWidth () {
        return {
          width: this.$vars.theme.width + 'px'
        }
      }
  	},
    
    methods: {
      getModel (id) {
        var that = this
        api.post(config.bylApiPath, '/entInfo/get', { id: id }, function (r) { // 正常
          if (r) {
            that.logo = r.data.logo
          }
        })
      },
      getOrgIdByCode (code) {
        return new Promise(function (resolve, reject) {
          api.post(config.bylApiPath, '/entInfo/search', {code: code}, function (r) { // 正常
            resolve(r.data)
          })
        })
      }
    }
  }
</script>
<style module>
	.header {
		position: relative;
		height: 60px;
		margin: 0 auto;
	}
	.logo {
		width: 296px;
		height: 60px;
		padding-top: 10px;
		padding-bottom: 6px;
		padding-left: 10px;
	}
	.logo > img {
		height: 44px;
	}
	.qrcode { margin-right: 4px; }
	.app {
		margin-right: 16px;
	}
	.qrcode > img {
		width: 18px;
		height: 18px;
	}
	.el_menu-right {
		position: absolute;
		right: 120px;
		top: 0px;
		height: 18px;
		border-bottom: 0 !important;
		box-sizing: border-box;
	}
	.right {
		position: absolute;
		right: 10px;
		top: 22px;
		height: 18px;
		box-sizing: border-box;
	}
	.logout, .qrcode, .app {
		line-height: 18px;
		height: 18px;
		display: inline-block;
		vertical-align: top;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/pages/others/header.vue